export default class AppModal {
    constructor() {
        this.isInitialized = false;
    }

    initDOM() {
        if (this.isInitialized) return;

        const style = document.createElement('style');
        style.textContent = `
            #app-modal-overlay {
                position: fixed; inset: 0; background: rgba(0, 0, 0, 0.6); 
                display: flex; align-items: center; justify-content: center;
                z-index: 99999; opacity: 0; pointer-events: none; 
                transition: all 0.3s ease; backdrop-filter: blur(4px);
            }
            #app-modal-overlay.active { opacity: 1; pointer-events: all; }
            #app-modal-box {
                background: #fff; border-radius: 12px; padding: 30px 20px; 
                max-width: 400px; width: 90%; text-align: center;
                transform: translateY(-30px); transition: transform 0.3s ease;
                box-shadow: 0 10px 30px rgba(0,0,0,0.2);
            }
            #app-modal-overlay.active #app-modal-box { transform: translateY(0); }
            
            .modal-icon { 
                width: 60px; height: 60px; border-radius: 50%; display: flex; 
                align-items: center; justify-content: center; margin: 0 auto 15px; 
                font-size: 32px; font-weight: bold;
            }
            .modal-success .modal-icon { background: #E8F5E9; color: #4CAF50; }
            .modal-error .modal-icon { background: #FFEBEE; color: #F44336; }
            
            #app-modal-title { font-size: 22px; margin: 0 0 10px; color: #222; font-family: sans-serif; }
            #app-modal-text { font-size: 15px; color: #666; margin: 0 0 25px; line-height: 1.5; font-family: sans-serif; }
            
            #app-modal-btn { 
                background: #222; color: #fff; border: none; padding: 12px 30px; 
                border-radius: 8px; cursor: pointer; font-size: 15px; transition: 0.2s;
            }
            #app-modal-btn:hover { background: #444; }
            .modal-success #app-modal-btn { background: #4CAF50; }
            .modal-success #app-modal-btn:hover { background: #43A047; }
            .modal-error #app-modal-btn { background: #F44336; }
            .modal-error #app-modal-btn:hover { background: #E53935; }
        `;
        document.head.appendChild(style);

        const overlay = document.createElement('div');
        overlay.id = 'app-modal-overlay';
        overlay.innerHTML = `
            <div id="app-modal-box">
                <div id="app-modal-icon" class="modal-icon"></div>
                <h3 id="app-modal-title"></h3>
                <p id="app-modal-text"></p>
                <button id="app-modal-btn">Tamam</button>
            </div>
        `;
        document.body.appendChild(overlay);

        this.overlayEl = overlay;
        this.boxEl = document.getElementById('app-modal-box');
        this.iconEl = document.getElementById('app-modal-icon');
        this.titleEl = document.getElementById('app-modal-title');
        this.textEl = document.getElementById('app-modal-text');
        this.btnEl = document.getElementById('app-modal-btn');

        this.btnEl.addEventListener('click', () => this.close());
        this.overlayEl.addEventListener('click', (e) => {
            if (e.target === this.overlayEl) this.close();
        });

        this.isInitialized = true;
    }

    show({ type = 'success', title = '', message = '', buttonText = 'Tamam' }) {
        this.initDOM(); 

        this.titleEl.textContent = title;
        this.textEl.textContent = message;
        this.btnEl.textContent = buttonText;
        
        this.boxEl.className = `modal-${type}`;
        this.iconEl.innerHTML = type === 'success' ? '✓' : '✕';

        this.overlayEl.classList.add('active');
    }

    close() {
        if(this.overlayEl) {
            this.overlayEl.classList.remove('active');
        }
    }
}